import React, { forwardRef, useEffect, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Title from "./Title";
import { useProjet } from "../Contexts/projet";
import { Button, Fab, TextField, Typography, withStyles } from "@material-ui/core";
import AddIcon from "@material-ui/icons/Add";
import Slide from "@material-ui/core/Slide";
import timelogAPI from "../Api/timelogAPI";
import { useUser } from "../Contexts/user";

const useStyles = makeStyles((theme) => ({
  container: {
    overflowY: "none",
    position: "relative",
  },
  table: {
    marginTop: 20,
  },
  fabContainer: {
    position: "absolute !important",
    top: 10,
    right: 20,
  },
  fab: {
    marginLeft: "10px"
  },
  form: {
    display: "flex",
    flexDirection: "column",
  },
  titleForm: {
    marginBottom: "30px",
  },
  contentForm: {},
  modal: {
    width: "300px",
  },
  actions: {
    display: "flex",
    justifyContent: "space-around",
  },
  itemAction: {
    marginLeft: "5px",
    marginRight: "5px",
  },
  butonAction: {
    marginLeft: "5px",
    marginRight: "5px",
    marginTop: "8px",
  },
}));

const Transition = forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function TasksTableAgence() {
  const classes = useStyles();
  const { tasks, getTimeTask, workflows, getWorkflowTask } = useProjet();
  const [open, setOpen] = useState(false);
  const [times, setTimes] = useState([]); 
  const { token } = useUser();

  useEffect(() => {
    if (Array.isArray(tasks)) setTimes(tasks.map(() => "00:00"));
  }, [tasks, getTimeTask, workflows, getWorkflowTask]);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const onTimeChange = (index, value) => {
    setTimes((prev) => {
      prev[index] = value;
      return Array.from(prev);
    });
  };

  const onAddTime = (task, index) => {
    let time = times[index];
    let timeSplit = time.split(":");
    time =
      timeSplit[0] +
      ((timeSplit[1] < 60 ? timeSplit[1] : 59) / 60 + "").substring(1);
    if (time.charAt(0) === "0") time = time.substring(1);
    timelogAPI
      .createTimeLog(token, task.id, time)
      .then(() => setTimes(tasks.map(() => "00:00")));
  };

  const getTypoColor = (workflow) => {
    const TextTypography = withStyles({
      root: {
        color: workflow.color.toLowerCase(),
      },
    })(Typography);
    return (
      <TextTypography component="p">
        {workflow.name}
      </TextTypography>
    );
  };

  return (
    <>
      {tasks && (
        <div className={classes.container}>
          <Title>Liste des tâches </Title>
          <Table size="small" className={classes.table}>
            <TableHead>
              <TableRow>
                <TableCell>Date de début</TableCell>
                <TableCell>Date de fin</TableCell>
                <TableCell>Titre</TableCell>
                <TableCell>Nombre de heures</TableCell>
                <TableCell>Status</TableCell>
                <TableCell style={{ width: 400 }} align="center">
                  Action
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {workflows.length > 0 &&
                tasks.length > 0 &&
                tasks.map((task, index) => (
                  <TableRow key={task.id}>
                    <TableCell>{task.dates.start}</TableCell>
                    <TableCell>{task.dates.due}</TableCell>
                    <TableCell>{task.title}</TableCell>
                    <TableCell>{getTimeTask(task)}</TableCell>
                    <TableCell>{getTypoColor(getWorkflowTask(task))}</TableCell>
                    <TableCell align="center">
                      <TextField
                        id="standard-basic"
                        label="Temps"
                        InputLabelProps={{
                          shrink: true,
                        }}
                        type="time"
                        value={times.length > 0 && times[index]}
                        onChange={(e) => onTimeChange(index, e.target.value)}
                        className={classes.itemAction}
                      />
                      <Button
                        variant="contained"
                        color="primary"
                        onClick={() => onAddTime(task, index)}
                        className={classes.butonAction}
                      >
                        Ajouter
                      </Button>
                      <Button
                        variant="contained"
                        color="primary"
                        href={task.permalink}
                        target="_blank"
                        className={classes.butonAction}
                      >
                        Ouvrir
                      </Button>
                    </TableCell>
                  </TableRow>
                ))}
            </TableBody>
          </Table>
        </div>
      )}
    </>
  );
}
